import Vue from 'vue'
import VueRouter from 'vue-router'
import search from '../views/search/index.vue'
import weixin from '../views/weixin/index.vue'
import productInfo from '../views/productInfo/index.vue'
import saoyisao from '../views/saoyisao/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'search',
    component: search
  },
  {
    path: '/weixin',
    name: 'weixin',
    component: weixin
  },
  {
    path: '/productInfo',
    name: 'productInfo',
    component: productInfo
  },
  {
    path: '/saoyisao',
    name: 'saoyisao',
    component: saoyisao
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
